export const ON_PROBATION_PERIOD = 'onProbationPeriod';
export const ON_STAFF = 'onStaff';
export const GOING_ON_PARENTAL_LEAVE = 'goingOnParentalLeave';
export const ON_PARENTAL_LEAVE = 'onParentalLeave';
export const UNDER_TERMINATION = 'underTermination';
export const TERMINATED = 'terminated';